import { render, staticRenderFns } from "./ChartPoliticiansForEachProvider.vue?vue&type=template&id=032a156c&"
import script from "./ChartPoliticiansForEachProvider.vue?vue&type=script&lang=js&"
export * from "./ChartPoliticiansForEachProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ChartPoliticiansForEachProvider.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports